import VAVsPortfolio from '@/Core.Service.Domain/Controls/VAVs/Views/IndexView.vue';

import EditVAV from '@/Core.Service.Domain/Controls/VAVs/Views/EditVAV.vue';

export const VAVsRoute = {
  path: 'vavs',
  name: 'VAVsPortfolio',
  component: VAVsPortfolio,
  children: [
    {
      path: 'history/:id',
      name: 'VAVHistory',
    },
  ],
  meta: {
    placeholder: 'Search for a VAV',
    controlTypeName: 'VAV',
    controlTypeId: 6,
    label: 'VAVs',
    toolTip: 'VAV',
    permission: 'controls:read',
    requiresSiteProperty: 'hasVariableAirVolumeUnits',
  },
};

export const EditVAVRoute = {
  path: 'site/:siteId/edit-vav/:deviceId',
  name: 'EditVAV',
  props: true,
  component: EditVAV,
  meta: {
    label: 'Edit VAV',
    toolTip: 'Edit VAV',
    permission: 'controls:update',
    requiresSiteProperty: 'hasVariableAirVolumeUnits',
  },
};
